import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { RootState } from 'store/configureStore';
import { openAlert } from 'store/slices/alertbar/alertbarSlice';
import { TOAST_MESSAGE } from 'constants/helperText';
import {
  fetchAuthImgUrl,
  signArbitrationAgreement,
} from 'services/ArbitrationAgreement/ArbitrationAgreementService';
import { arbitrationAgreementSliceActions } from 'store/slices/arbitrationAgreement/arbitrationAgreementSlice';
import { credentialActions } from 'store/slices/credentials/credentialSlice';
import { logger } from 'services/logging/appInsights';

const signatureSelector = (state: RootState) =>
  state.arbitrationAgreement.signature;
const userIdSelector = (state: RootState) => state.auth.userId;
const signatureImgUrlSelector = (state: RootState): string | undefined =>
  state?.arbitrationAgreement?.currentArbitrationAgreement?.agreement
    ?.authorizedSignatorySignatureImageUrl;

export function* getAuthImgUrlWatcher() {
  try {
    const imgUrl = yield select(signatureImgUrlSelector);
    if (imgUrl) {
      const authImgUrlResponse = yield call(fetchAuthImgUrl, imgUrl);
      if (authImgUrlResponse?.data?.fileUrl) {
        yield put(
          arbitrationAgreementSliceActions.setAuthSignatureImgUrl(
            authImgUrlResponse?.data?.fileUrl,
          ),
        );
      }
    }
  } catch (err: any) {
    logger.error(err, 'getAuthImgUrlWatcher', 'ArbitrationAgreementSaga.ts');
  }
}

export function* signArbitrationAgreementWatcher(action) {
  const { actionItemId } = action.payload;
  try {
    const userId: string = yield select(userIdSelector);
    const signature: string = yield select(signatureSelector);
    const signResponse = yield call(signArbitrationAgreement, {
      userId,
      actionItemId,
      signature,
    });
    if (signResponse?.status === 200 && signResponse?.data?.isCreated) {
      yield put(
        openAlert({
          variant: 'success',
          message: TOAST_MESSAGE.ChangesSaved,
        }),
      );
    }
  } catch (e: any) {
    logger.error(
      e,
      'signArbitrationAgreementWatcher',
      'ArbitrationAgreementSaga.ts',
    );
  }
}

export function* arbitrationAgreementSaga() {
  yield all([
    takeLatest(
      arbitrationAgreementSliceActions.getAuthorizedImgUrl.type,
      getAuthImgUrlWatcher,
    ),
    takeLatest(
      arbitrationAgreementSliceActions.signArbitrationAgreement.type,
      signArbitrationAgreementWatcher,
    ),
  ]);
}
